// Static, hand-curated Region list for the footer locale switcher (spec-029).
// Only entries here are ever selectable or visible — no disabled/"coming
// soon" placeholders for regions that haven't shipped yet (FR-011).
// Adding a new region (e.g. Uruguay) is a new entry here + a matching
// lib/router.ts Locale union extension — nothing else changes (FR-007, SC-005).

export interface Region {
  /** ISO country code, lowercase — matches circle-flags' flags/{code}.svg and lib/router.ts's Locale values. */
  code: string
  /** i18n key (relative to the 'navigation' namespace — this array is only ever consumed via useTranslation('navigation')) for the display name (FR-014). */
  nameKey: string
  /** Static, hand-curated — not computed from traffic/signup data (Clarifications, 2026-07-19). */
  isTopCountry: boolean
}

export const REGIONS: Region[] = [
  { code: 'us', nameKey: 'chrome.locale.regions.us', isTopCountry: true },
]
